import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";
import CommandesTab from "@/features/ventes/components/commandes/CommandesTab";

export const Route = createFileRoute("/_app/ventes/commandes/")({
  staticData: {
    title: "Commandes",
    icon: FileText,
    tab_icon: FileText,
    permission: PERMISSIONS.VENTES.COMMANDES.VIEW,
    module: "ventes",
    order: 30,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion des commandes",
  },
  component: CommandesTab,
});
